import { RadioGroupState } from "@react-stately/radio";
import { createContext } from "react";
import { ToggleGroupSize } from "./ToggleGroupRoot";

export type ToggleGroupContextValue = {
  size: ToggleGroupSize;
  state: RadioGroupState;
};

export const ToggleGroupContext = createContext<ToggleGroupContextValue | null>(
  null
);
